import {
    Box,
    Button,
    Container,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    ListItem,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    UnorderedList,
    useToast,
} from '@chakra-ui/react';
import * as Sentry from '@sentry/react';

import {useNavigate, useParams} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {laravelAxios} from "../../Comp/apiClients/laravelClient";
import {Helmet} from "react-helmet";
import TailSpinLoader from "../../Comp/ui/loaders/TailSpinLoader";

export const Mode = {
    NEW: 1, EDIT: 2
}

export const NewRole = (props) => {
    const toast = useToast();
    const navigate = useNavigate();
    const {id} = useParams();
    const [permissionList, setPermissionList] = useState([]);
    const [roleTitle, setRoleTitle] = useState('');
    const [rolePermissions, setRolePermissions] = useState({});
    const [roleTitleError, setRoleTitleError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getAllPermissionList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.mode === Mode.NEW) {
            bootstrapPermissions();
        } else {
            bootstrapPermissionFromApi(id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissionList]);

    const bootstrapPermissionFromApi = async (id) => {
        try {
            const res = await laravelAxios.get(`/roles/${id}`);
            setRoleTitle(res.data['data']['label']);
            setRolePermissions(res.data['data']['permission_list']);
        } catch (err) {
            Sentry.captureException(err, {
                tags: { section: 'newrole', function: 'bootstrapPermissionFromApi' },
                extra: { id, error: err, message: err?.message, stack: err?.stack }
            });
        }
    }

    function bootstrapPermissions() {
        for (let i = 1; i <= permissionList.length; i++) {
            changePermissions(i, 1);
        }
    }

    const changePermissions = (name, value) => {
        setRolePermissions((preValue) => {
            return {
                ...preValue, [`P${name}`]: value
            }
        })
    }

    const getAllPermissionList = async () => {
        try {
            const res = await laravelAxios.get('/permission_list')
            const permissions = []
            for (const role of res.data) {
                permissions.push({
                    key: role['id'],
                    value: role['title'],
                    max_level: role['max_level'],
                    is_heading: role['is_heading']
                });
            }
            setPermissionList(permissions);
        } catch (err) {
            Sentry.captureException(err, {
                tags: { section: 'newrole', function: 'getAllPermissionList' },
                extra: { error: err, message: err?.message, stack: err?.stack }
            });
        }
    }

    const saveRoleDetails = async () => {
        if (!roleTitle) {
            setRoleTitleError('Enter Role Title Name');
            return;
        }
        const payload = {
            label: roleTitle, permission_list: rolePermissions
        }
        setIsLoading(true);
        try {
            const res = await laravelAxios.post('/roles', payload)
            setIsLoading(false);
            if (res.data['data']) {
                setRoleTitle('');
                setRoleTitleError('');
                bootstrapPermissions();
                toast({title: 'Role Saved Successfully', status: 'success', isClosable: true})
                navigate(-1);
            }
        } catch (err) {
            setIsLoading(false);
            Sentry.captureException(err, {
                tags: { section: 'newrole', function: 'saveRoleDetails' },
                extra: { payload, error: err, message: err?.message, stack: err?.stack }
            });
            if (err.response && err.response.data && err.response.data['errors']) {
                const errors = err.response.data['errors'];
                if (errors['title']) setRoleTitleError(errors['title'][0]);
            }
        }
    }

    function getActiveClass(key, valueToCheck) {
        if (rolePermissions[`P${key}`] === valueToCheck || rolePermissions[`p${key}`] === valueToCheck) {
            return 'manage_roles1';
        } else {
            return 'manage_roles2';
        }
    }

    const updateRoleDetails = async () => {
        if (!roleTitle) {
            setRoleTitleError('Title Name Can\'t be Empty');
            return;
        }
        const payload = {
            label: roleTitle, permission_list: rolePermissions
        }
        setIsLoading(true);
        try {
            const res = await laravelAxios.put(`/roles/${id}`, payload)
            setIsLoading(false);
            if (res.data['data']) {
                setRoleTitle('');
                setRoleTitleError('');
                bootstrapPermissions();
                toast({title: 'Role Updated Successfully', status: 'success', isClosable: true})
                navigate(-1);
            }
        } catch (err) {
            setIsLoading(false);
            Sentry.captureException(err, {
                tags: { section: 'newrole', function: 'updateRoleDetails' },
                extra: { payload, error: err, message: err?.message, stack: err?.stack }
            });
            if (err.response && err.response.data && err.response.data['errors']) {
                const errors = err.response.data['errors'];
                if (errors['title']) setRoleTitleError(errors['title'][0]);
            }
        }
    }

    return (<Container className='project_br'>
        <Helmet>
            <title>Role Details</title>
        </Helmet>
        <Flex backgroundColor={"#F2F2F2"} alignItems={"center"} justifyContent={"space-between"}>
            <Box className='bd_crum qt_mb_pg'>
                <Box className='pages_project_bar_sub_heading'>USERS / Create ROLES</Box>
                <Heading as="h1" className='pages_project_bar_heading'>
                    {props.mode === Mode.NEW ? "New Role" : "Update Role"}
                </Heading>
                <Text onClick={() => navigate(-1)}>Back</Text>
            </Box>
            <Flex mr={"25px"}>
                <Button className={"orange_button_drillcut"}
                        onClick={props.mode === Mode.NEW ? saveRoleDetails : updateRoleDetails}>SAVE DETAILS</Button>
                <TailSpinLoader isLoading={isLoading} wrapperStyle={{marginTop: '5px'}}/>
            </Flex>
        </Flex>
        {/*<Box className="bg_color_acrhove">*/}
        {/*    <Avatar className='icon' src={archive}/>*/}
        {/*    <span className='dt_archive'>Archive</span>*/}
        {/*</Box>*/}
        <Box className="rl_dets">
            <Heading> Role Details</Heading>
            <FormControl isInvalid={roleTitleError}>
                <FormLabel htmlFor='title'>Role Title</FormLabel>
                <Input id='title' type='title' onChange={(event) => {
                    setRoleTitleError('');
                    setRoleTitle(event.target.value);
                }} value={roleTitle}/>
                <FormErrorMessage>{roleTitleError}</FormErrorMessage>
            </FormControl>
        </Box>
        <Box>
            <TableContainer className="tble_dt edit_roles">
                <Heading>Permissions</Heading>
                <Table>
                    <Thead>
                        <Tr className="main_th">
                            <Th>Action</Th>
                            <Th>PERMISSIONS</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {permissionList && permissionList.map((element) => {
                            // console.log(element)
                            return (<>
                                {element['is_heading'] === 1 && <Tr height="30px">
                                    <Td/>
                                    <Td/>
                                </Tr>}
                                <Tr>
                                    <Td fontWeight={element['is_heading'] === 1 ? '700 !important;' : '500'}
                                        textTransform={element['is_heading'] === 1 ? 'uppercase' : 'none'}>{element['value']}</Td>
                                    <Td>
                                        <UnorderedList>
                                            {element['max_level'] >= 0 && <ListItem cursor="pointer"
                                                                                    onClick={() => changePermissions(element['key'], 0)}>
                                                <span className={getActiveClass(element['key'], 0)}>Hide</span>
                                            </ListItem>}
                                            {element['max_level'] >= 1 && <ListItem cursor="pointer"
                                                                                    onClick={() => changePermissions(element['key'], 1)}>
                                                <span className={getActiveClass(element['key'], 1)}>View</span>
                                            </ListItem>}
                                            {element['max_level'] >= 2 && <ListItem cursor="pointer"
                                                                                    onClick={() => changePermissions(element['key'], 2)}>
                                                <span className={getActiveClass(element['key'], 2)}>Edit</span>
                                            </ListItem>}
                                            {element['max_level'] >= 3 && <ListItem cursor="pointer"
                                                                                    onClick={() => changePermissions(element['key'], 3)}>
                                                <span className={getActiveClass(element['key'], 3)}>Create</span>
                                            </ListItem>}
                                        </UnorderedList>
                                    </Td>
                                </Tr></>)
                        })}
                    </Tbody>
                </Table>

            </TableContainer>
            <Box className="bg_strip_btn_save">
                <Text width="fit-content" color={'#EC7700'} className="chakra-text" cursor="pointer"
                      onClick={() => navigate(-1)}>Cancel</Text>
                <Button onClick={props.mode === Mode.NEW ? saveRoleDetails : updateRoleDetails}>SAVE DETAILS</Button>
                <TailSpinLoader isLoading={isLoading} wrapperStyle={{marginTop: '5px'}}/>
            </Box>
        </Box>
    </Container>)
}